// extracted by mini-css-extract-plugin
export var avatarContainer = "_6s-0";
export var avatarTypingWave = "_6s-i";
export var gray = "_6s-f";
export var green = "_6s-c";
export var icon = "_6s-9";
export var image = "_6s-1";
export var lg = "_6s-6";
export var md = "_6s-5";
export var presenceDot = "_6s-b";
export var red = "_6s-d";
export var sm = "_6s-4";
export var status = "_6s-a";
export var typingDot = "_6s-h";
export var typingPill = "_6s-g";
export var xl = "_6s-7";
export var xs = "_6s-3";
export var xxl = "_6s-8";
export var xxs = "_6s-2";
export var yellow = "_6s-e";